import React from 'react';
import { Link } from 'react-router-dom';

interface FAQ {
  id: number;
  question: string;
  answer: string;
  href: string;
}

export default function FAQ({ faqs }: { faqs: FAQ[] }) {
  return (
    <div className='mx-auto mt-32 max-w-7xl px-6 sm:mt-40 lg:px-8'>
      <div className='mx-auto max-w-4xl divide-y divide-gray-900/10'>
        <h2 className='text-2xl font-bold leading-10 tracking-tight text-gray-900 dark:text-white'>
          Frequently asked questions
        </h2>
        <dl className='mt-10 space-y-6 divide-y divide-gray-900/10'>
          {faqs.map((faq) => (
            <div key={faq.id} className='pt-6'>
              <dt>
                <Link to={faq.href} className='text-lg font-semibold leading-7 text-gray-900 dark:text-white hover:text-yellow-500 transition-colors'>
                  {faq.question}
                </Link>
              </dt>
              <dd className='mt-2 ml-0 text-base leading-7 text-gray-600 dark:text-gray-400'>{faq.answer}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
